import { FC } from "react";
import { CloseButton as ChakraCloseButton, CloseButtonProps } from "@chakra-ui/react";

import { CloseIcon } from "@shared/components/Icons";

// Chakra v2 close button look; v3's is the orange `ghost` IconButton.
const CloseButton: FC<CloseButtonProps> = (props) => (
  <ChakraCloseButton
    variant="plain"
    boxSize={8}
    minW={8}
    px={0}
    color="inherit"
    fontSize="10px"
    borderRadius="md"
    _hover={{ bg: "blackAlpha.100" }}
    _active={{ bg: "blackAlpha.200" }}
    {...props}
  >
    <CloseIcon />
  </ChakraCloseButton>
);

export default CloseButton;
